<template>
  <div>
    <v-dialog
        v-model="dialogShow"
        @keydown.esc.prevent="closeForm"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >

      <v-card>
        <v-form v-model="valid" ref="form">
          <v-toolbar dark color="pink lighten-1" class="color-gradient-1" dense>
            <v-btn icon dark @click="closeForm" v-if="false">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn dark @click="backOrClose" class="ml-1 rounded-lg" outlined small v-if="true">
              <v-icon>mdi-arrow-left</v-icon>
              Close
            </v-btn>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="save"
                :disabled="!valid || isItemModified === false"
                class="hidden-md-and-up"
              >
              </v-btn>
            </v-toolbar-items>

            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="save"
                  :disabled="!valid || isItemModified === false"
                  class="hidden-md-and-up"
              >
                Simpan
              </v-btn>
            </v-toolbar-items>

          </v-toolbar>

          <v-card-title class="text-uppercase grey--text" v-if="false">
            <span v-if="formMode === 'EDIT_FORM'">EDIT </span>
            <span class="font-weight-light ml-1 mr-1">ITEM</span>
            <span v-if="formMode === 'NEW_FORM'"> BARU</span>
            <v-chip
              class="ma-2"
              color="warning"
              outlined
              x-small
              v-show="isItemModified"
            >
              <v-icon left> mdi-pencil </v-icon>
              modified
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-container>

              <v-card elevation="6" class="rounded-lg">
                <v-card-text>
                  <v-container>

                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                            v-model="itemModified.description"
                            label="Nama Viral/Brand UMKM*"
                            outlined
                            :rules="rulesNotEmtpy"
                            hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="8" sm="8" md="4">
                        <v-text-field
                            v-model="itemModified.namaPemilik"
                            label="Nama Pemilik"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="8" sm="8" md="4">
                        <v-select
                            v-model="itemModified.fdivisionBean"
                            :items="itemsFDivision"
                            item-value="id"
                            item-text="description"
                            label="Divisi"
                            outlined
                            dense
                            hide-details
                        ></v-select>
                      </v-col>
                      <v-col cols="4" sm="4" md="4">
                        <v-switch
                            v-if="true"
                            v-model="itemModified.statusActive"
                            :label="itemModified.statusActive ? 'Aktif' : 'Non-Aktif'"
                            x-small
                            hide-details
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-2">
                      <v-col cols="12" sm="6" md="6" class="d-flex">
                        <v-icon color="primary" v-if="itemModified.kode1Valid">mdi-check-circle</v-icon>
                        <v-icon color="red" v-if="! itemModified.kode1Valid">mdi-window-close</v-icon>
                        <v-text-field
                            v-model="itemModified.kode1"
                            label="NIB (Nomor Induk Berusaha)"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col class="mt-2" cols="6" sm="4" md="3">
                        <v-btn
                            class="ml-2 rounded-lg"
                            color="primary"
                            outlined
                            @click="checkNIB"
                        >
                          Check NIB
                        </v-btn>
                      </v-col>
                      <v-col cols="6" sm="4" md="3">
                        <div class="caption ml-1 ">
                          <div>
                            Pengecekan terakhir
                          </div>
                          <div class="align-content-center mt-n1 font-weight-bold">
                            {{ itemModified.lastValidate ? formattedDatefns(itemModified.lastValidate) : '' }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-2">
                      <v-col cols="12" sm="6" md="6" class="d-flex">
                        <v-icon color="primary" v-if="itemModified.merkValid">mdi-check-circle</v-icon>
                        <v-icon color="red" v-if="! itemModified.merkValid">mdi-window-close</v-icon>
                        <v-text-field
                            v-model="itemModified.merk"
                            label="Merk"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col class="mt-1" cols="6" sm="4" md="3">
                        <v-btn
                            @click="checkMerk"
                            class="ml-2 rounded-lg"
                            color="primary"
                            outlined>
                          Check Merk
                        </v-btn>
                      </v-col>
                      <v-col cols="6" sm="4" md="3">
                        <div class="caption ml-1 ">
                          <div>
                            Pengecekan terakhir
                          </div>
                          <div class="align-content-center mt-n1 font-weight-bold">
                            {{ itemModified.merkValidateAt ? formattedDatefns(itemModified.merkValidateAt) : '' }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                            v-model="itemModified.namaBadanUsaha"
                            label="Nama Badan Usaha pada NIB"
                            outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row no-gutters class="mt-4">
                      <v-col cols="12" sm="12" md="4">
                        <v-menu
                            v-model="menuDate1"
                            :close-on-content-click="false"
                            max-width="290"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDatefns(tanggalBerdiri1)"
                                prepend-inner-icon="mdi-calendar"
                                clearable
                                label="Tanggal berdiri"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="tanggalBerdiri1 = null"
                                outlined
                                dense
                            ></v-text-field>
                          </template>

                          <v-date-picker
                              v-model="tanggalBerdiri1"
                              @change="menuDate1 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-select
                            v-model="itemModified.jenisBadanUsaha"
                            :items="itemsJenisBadanUsaha"
                            item-value="id"
                            item-text="description"
                            label="Jenis Badan Usaha"
                            outlined
                            dense
                            :class="$vuetify.breakpoint.smAndDown? 'ml-0': 'ml-2' "
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-select
                            v-if="true"
                            v-model="itemModified.fumkmTypeBean"
                            :items="itemsFUmkmType"
                            item-value="id"
                            item-text="description"
                            label="Kelompok UMKM"
                            outlined
                            dense
                            :class="$vuetify.breakpoint.smAndDown? 'ml-0': 'ml-2' "
                        ></v-select>
                      </v-col>

                    </v-row>

                    <v-row no-gutters >
                      <v-col cols="12" :class="$vuetify.breakpoint.smAndDown? 'flex-column': 'd-flex' ">
                        <div v-for="item in itemsFPermit" :key="item.id">
                          <v-checkbox
                              v-model="itemModified.itemsPermit"
                              :label="item.description"
                              :value="item.id"
                              class="mr-8 no-gutters"
                              dense
                              ></v-checkbox>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row no-gutters class="mt-4">
                      <v-col cols="12" sm="12" md="3">
                        <v-text-field
                            v-model="itemModified.emplMale"
                            label="Jml Karyawan Pria"
                            outlined
                            dense
                            type="number"
                            prepend-inner-icon="mdi-account-multiple-outline"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="3">
                        <v-text-field
                            v-model="itemModified.emplFemale"
                            label="Jml Karyawan Wanita"
                            outlined
                            dense
                            type="number"
                            prepend-inner-icon="mdi-account-multiple-outline"
                            :class="$vuetify.breakpoint.smAndDown? 'ml-0': 'ml-2' "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="3">
                        <v-text-field
                            v-model="itemModified.modal"
                            label="Modal"
                            outlined
                            dense
                            type="number"
                            prepend-inner-icon="mdi-cash"
                            :class="$vuetify.breakpoint.smAndDown? 'ml-0': 'ml-2' "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" v-if="false">
                        <v-text-field
                            v-model="itemModified.jumlahKaryawan"
                            label="Jumlah Karyawan"
                            outlined
                            dense
                            type="number"
                            prepend-inner-icon="mdi-account-multiple-outline"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="3">
                        <v-text-field
                            v-model="itemModified.omset"
                            label="Omset (Rp)"
                            outlined
                            dense
                            type="number"
                            prepend-inner-icon="mdi-store"
                            :class="$vuetify.breakpoint.smAndDown? 'ml-0': 'ml-2' "
                        ></v-text-field>
                      </v-col>

                    </v-row>

                  </v-container>

                  <v-row class="d-flex">
                    <v-col cols="12" sm="12" md="6">
                      <v-hover v-slot="{ hover }">
                        <v-card
                            max-height="480px"
                            max-width="420px"
                            class="mb-4"
                            :elevation="hover ? 10 : 1"
                            :class="[{ 'on-hover': hover },hover ? 'card-hover-opacity': 'card-not-hover-opacity']"
                        >
                          <v-img
                              :lazy-src="lookupImageUrlLazy(itemModified)"
                              :src="lookupImageUrl(itemModified)"
                              max-height="480px"
                              max-width="420px"
                              contain
                          >
                            <v-card-title
                                class="text-h6 white--text fill-height"
                            >
                              <v-row
                                  class="fill-height flex-column"
                                  justify="space-between"
                              >
                                <v-spacer />
                                <div class="align-self-center">
                                  <v-btn
                                      :class="{ 'show-btns': hover }"
                                      :color="transparent"
                                      icon
                                      large
                                      dark
                                      outlined
                                      @click="showDialogUpload"
                                  >
                                    <v-icon
                                        :class="{ 'show-btns': hover }"
                                        :color="transparent"
                                        large
                                    >
                                      mdi-upload
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </v-row>
                            </v-card-title>
                          </v-img>

<!--                          {{ itemModified.avatarImage }}-->

<!--                          {{ lookupImageUrl(itemModified) }}-->
                        </v-card>
                      </v-hover>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-row no-gutters>
                        <v-col cols="12" sm="12" md="12">
                          <v-textarea
                              v-model="itemModified.address"
                              label="Alamat"
                              outlined
                              dense
                              rows="2"
                          ></v-textarea>
                        </v-col>
                      </v-row>

                      <v-row no-gutters class="mt-n4">
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="itemModified.fsubAreaBean"
                              :items="computedItemsFSubArea"
                              item-text="description"
                              item-value="id"
                              label="Kecamatan-Kab/Kota"
                              outlined
                              dense
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row class="grey lighten-4 mt-n4">
                        <v-col cols="12" sm="12" md="12"  class="d-flex">
                          <v-text-field
                              v-model="itemModified.lat"
                              label="Latitude"
                              outlined
                              dense
                          ></v-text-field>
                          <v-text-field
                              v-model="itemModified.lon"
                              label="Longitude"
                              outlined
                              dense
                              class="ml-1"
                          ></v-text-field>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                  small
                                  color="primary"
                                  class="rounded-lg ml-1"
                                  @click="taqKoordinat"
                                  v-on="on"
                              >
                                <v-icon small>mdi-google-maps</v-icon>
                              </v-btn>
                            </template>
                            <span class="yellow--text">Klik untuk dapatkan koordinat anda berada saat ini</span>
                          </v-tooltip>

                        </v-col>
                      </v-row>

                      <v-row no-gutters class="mt-n4">
                        <v-col cols="12">
                          <FUmkmMarker
                              ref="refUmkmMarker"
                              :singleMarker="computedCurrentMarker"
                              @updateSingleMarker="updateSingleMarker"
                          ></FUmkmMarker>
                        </v-col>
                      </v-row>

                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                          v-model="itemModified.notes"
                          label="Deskripsi/Copy Writing dari Usaha"
                          outlined
                          dense
                          rows="3"
                          auto-grow
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                          v-model="itemModified.needs"
                          label="Kebutuhan Akan Investasi dari Investor"
                          outlined
                          dense
                          rows="2"
                          auto-grow
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <FUmkmDokumentasi
                  :itemModified="itemModified"
                  :parendId="itemModified.id"
                  :itemsFile="itemsFile"
                  @retrieveFiles="retrieveFiles"
              >
              </FUmkmDokumentasi>
              <div class="mt-6 elevation-6 pa-3 rounded-lg ">
                <FUmkmObjectFileTable
                    ref="refFUmkmFileTable"
                    :itemModified="itemModified"
                    :newFMeetingId="itemModified.id"
                    @saveCreateOnly="saveCreateOnly"
                ></FUmkmObjectFileTable>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-chip
              class="ml-4"
              color="error"
              outlined
              close
              small
              v-if="errorMessage"
            >
              {{ errorMessage }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="closeForm"
              class="hidden-sm-and-down"
            >
              Batal
            </v-btn>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="save"
              :disabled="!valid || isItemModified === false"
              class="hidden-sm-and-down"
            >
              Simpan
            </v-btn>
            <span class="mr-16"></span>
          </v-card-actions>
        </v-form>
      </v-card>

      <UploadImageDialog
          ref="refUploadDialog"
          @eventUploadSuccess="completeUploadSuccess"
      ></UploadImageDialog>

      <close-confirm-dialog
        ref="refCloseConfirmDialog"
        @eventFromCloseConfirm="passingEventFromCloseConfirm"
      ></close-confirm-dialog>

      <v-snackbar v-model="snackbar">
        {{ snackBarMesage }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
import FUmkmService from "@/services/apiservices-umkm/f-umkm-service";

import CloseConfirmDialog from "@/components/utils/CloseConfirmDialog.vue";
import FormMode from "@/models/form-mode";
import FUmkm from "@/models/umkm/f-umkm";
import { format, parseISO } from "date-fns";
import FUmkmDokumentasi from "./FUmkmObjectDialogPhotos.vue";
import FUmkmFileService from "@/services/apiservices-umkm/f-umkm-file-service";
import FileService from "../../services/apiservices-umkm/file-service";
import UploadImageDialog from "@/components/utils-umkm/UploadImageDialog.vue";
import FUmkmMarker from "./FUmkmObjectMarker.vue";
import FPermitService from "@/services/apiservices-umkm/f-permit-service";
import FUmkmTypeService from "@/services/apiservices-umkm/f-umkm-type-service";
import FAreaService from "@/services/apiservices/f-area-service";
import FSubAreaService from "@/services/apiservices/f-sub-area-service";
import EJenisBadanUsaha from "@/models/e-jenis-badan-usaha";
import axios from "axios";
import FtUmkmPermitService from "@/services/apiservices-umkm/ft-umkm-permit-service";
import FUmkmObjectFileTable from "@/components/admin-umkm-object/FUmkmObjectFileTable.vue";

export default {
  name: "FtUmkmObjectDialog",
  components: {
    FUmkmObjectFileTable,
    FUmkmMarker,
    UploadImageDialog,
    FUmkmDokumentasi,
    CloseConfirmDialog,
  },
  props: {
    // formMode: String,
  },
  data() {
    return {
      formMode: FormMode.EDIT_FORM,
      dialogShow: false,
      snackbar: false,
      snackBarMesage: '',
      title: "",
      errorMessage: "",
      message: "",
      rulesNotEmtpy: [(v) => !!v || "Tidak boleh kosong"],

      // tanggalBerdiri1: format(parseISO(new Date().toISOString()), "dd-MMM-yyyy"),
      menuDate1: false,
      // tanggalBerdiri2: format(parseISO(new Date().toISOString()), "dd-MMM-yyyy"),
      menuDate2: false,

      selectedItemIndex: -1,
      itemDefault: "",
      itemModified: new FUmkm(0, '', ''),
      selectFDivision: { id: 0, kode1: "", description: "" },
      itemsFDivision: [],
      itemsFArea: [],
      itemsFSubArea: [],
      itemsFile: [],
      valid: false,
      transparent: "rgba(255, 255, 255, 0)",

      itemsYear: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
      itemsFPermit: [],

      fumkmFiles: [],

      itemsFUmkmType: [],
      itemsJenisBadanUsaha: EJenisBadanUsaha,
    };
  },
  computed: {
    // itemModified: {
    //   get() {
    //     return this.$store.state.umkm.itemModified;
    //   },
    //   set(value) {
    //     this.$store.dispatch("umkm/updateItemModified", value);
    //   },
    // },
    // itemDefault: {
    //   get() {
    //     return this.$store.state.umkm.itemDefault;
    //   },
    //   set(value) {
    //     this.$store.dispatch("umkm/updateItemDefault", value);
    //   },
    // },
    isItemModified() {
      const defaultItem = JSON.stringify(this.itemDefault);
      const modifiedItem = JSON.stringify(this.itemModified);
      return defaultItem !== modifiedItem;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },

    computedCurrentMarker() {
      if (this.itemModified.lat && this.itemModified.lon) {
        return {
          coords: [ this.itemModified.lat, this.itemModified.lon]
        };
      } else {
        return undefined
      }
    },
    computedItemsFSubArea() {
      return this.itemsFSubArea.map( item => {
        return {
          id: item.id,
          description: item.description + " - " + this.lookupFArea(item.fareaBean).description
        }
      })
    },

    tanggalBerdiri1: {
      get() {
        try {
          const inputDate = new Date(this.itemModified.tanggalBerdiri);
          return inputDate.toISOString().split("T")[0];
        } catch (e) {
          return new Date().toISOString().split("T")[0];
        }
      },
      set(value) {
        this.itemModified.tanggalBerdiri = value;
      },
    },

  },

  watch: {},

  methods: {
    setDialogState(value) {
      this.dialogShow = value;
    },
    taqKoordinat() {

      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition(
            position => {
              // console.log(JSON.stringify(position))
              this.coordinates = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              };
              this.itemModified.lat = this.coordinates.latitude;
              this.itemModified.lon = this.coordinates.longitude;

              this.center = [this.coordinates.latitude, this.coordinates.longitude];
              this.$refs.refUmkmMarker.center = [this.coordinates.latitude, this.coordinates.longitude];

            },
            error => {
              this.error = 'Error getting location: ' + error.message;
              this.loading = false;
            }
        );
      } else {
        this.error = 'Geolocation is not supported by this browser.';
      }
    },
    checkNIB(){
      if(this.itemModified.kode1 !== '' &&
          this.itemModified.merk !== '' &&
          this.itemModified.fdivisionBean !== 0 &&
          this.itemModified.fsubAreaBean !== 0 &&
          this.itemModified.fumkmTypeBean !== 0 &&
          this.itemModified.description !== ''){
        const url = 'https://api-prd.oss.go.id/v1/reg/profile/nib';

        const headers = {
          'Accept': 'application/json, text/plain, */*',
          'Accept-Encoding': 'gzip, deflate, br, zstd',
          'Connection': 'keep-alive',
          'Content-Type': 'application/json',
          'Host': 'api-prd.oss.go.id',
          'Origin': 'https://oss.go.id',
          'Referer': 'https://oss.go.id/',
          'user_key': '846ee507525c6b00d18733e066bd5686',
        };

        const data = {
          dataNib: {
            // nib: '2601230031375'
            nib: this.itemModified.kode1
          }
        };

        axios.post(url, data, { headers })
            .then(response => {
              // console.log(JSON.stringify(response.data.data));
              // console.log(response.data.data.status_aktif);

              this.itemModified.kode1Valid = response.data.data.status_aktif === 'Aktif';
              this.itemModified.lastValidate = new Date()
              if (response.data.data.nama){
                this.itemModified.namaBadanUsaha = response.data.data.nama
              }
              if(this.itemModified.id === 0){
                this.saveCreateOnly()
              } else if(this.itemModified.id > 0){
                this.saveUpdateOnly()
              }
            })
            .catch(error => {
              this.itemModified.kode1Valid = false
              this.itemModified.lastValidate = new Date()
              if(this.itemModified.id === 0){
                this.saveCreateOnly()
              } else if(this.itemModified.id > 0){
                this.saveUpdateOnly()
              }
              console.error('Error:', error.response ? error.response.data : error.message);
            });
      } else {
        this.snackbar = true
        this.snackBarMesage = "Lengkapi semua data untuk check NIB"
      }


    },
    checkMerk(){
      if(this.itemModified.kode1 !== '' &&
          this.itemModified.merk !== '' &&
          this.itemModified.fdivisionBean !== 0 &&
          this.itemModified.fsubAreaBean !== 0 &&
          this.itemModified.fumkmTypeBean !== 0 &&
          this.itemModified.description !== ''){
        return
      } else {
        this.snackbar = true
        this.snackBarMesage = "Lengkapi semua data untuk check Merk"
      }


    },
    updateSingleMarker(valueMarker) {

      this.itemModified.lat = valueMarker.coords[0];
      this.itemModified.lon = valueMarker.coords[1];
    },

    showDialog(selectedIndex, item, itemsFDivision, itemsFUmkmType) {
      this.dialogShow = !this.dialogShow;
      if (selectedIndex > -1) {
        this.selectedIndex = selectedIndex;
        this.initializeEditMode(item);
      } else {
        this.itemDefault = new FUmkm(0, "", "")
        this.itemModified = new FUmkm(0, "", "")
        this.selectedIndex = -1
        this.$store.dispatch("permit/updateListFtUmkmPermit", []);
        this.itemsFile = [];
        /**
         * ##++ Tambahan untuk Child
         */
        try {
          this.$refs.refFUmkmFileTable.fumkmFiles = [];
        } catch (e) {
          //
        }
      }

      this.itemsFDivision = itemsFDivision;
      this.itemsFUmkmType = itemsFUmkmType;
    },


    showDialogUpload() {
      if (
          this.itemModified.description !== undefined &&
          this.itemModified.fdivisionBean !== undefined
      ) {
        if (this.itemModified.id === 0) {
          // this.$emit('eventSaveItemWithoutClose', false)
          this.saveCreateOnly();
        }
        this.$refs.refUploadDialog.showDialog();
      } else {
        this.snackBarMesage = "Kode, Deskripsi dan Divisi harus diisi dahulu";
        this.snackbar = true;
      }
    },
    saveCreateOnly() {
      if (this.itemModified.id === 0) {
        if(this.itemModified.itemsPermit){
          const ftUmkmPermits = this.itemModified.itemsPermit.map( itemId => {
            return {
              fumkmBean: 0,
              fpermitBean: itemId,
              fdivisionBean: this.itemModified.fdivisionBean,
            }
          });
          this.itemModified.itemsPermit = ftUmkmPermits
        }
        FUmkmService.createFUmkm(this.itemModified).then(
            (response) => {
              /**
               * dipaksa create Dahulu
               */
              // this.initializeEditMode(response.data)

              if(this.itemModified.itemsPermit){
                const newFtUmkmPermits = this.itemModified.itemsPermit.map( itemId => {
                  return {
                    fumkmBean: response.data.id,
                    fpermitBean: itemId.fpermitBean,
                    fdivisionBean: this.itemModified.fdivisionBean,
                  }
                });
                FtUmkmPermitService.deleteAllFtUmkmPermitByParent(response.data.id).then(
                    () => {

                      FtUmkmPermitService.createFtUmkmPermitMultiple(newFtUmkmPermits).then(
                          () => {
                            this.$emit("update:formMode", FormMode.EDIT_FORM);
                            this.itemModified.id = response.data.id;
                            this.initializeEditMode(this.itemModified)
                          },
                          (error) => {
                            console.log(error.response)
                          }
                      )
                    },
                    (error) => {
                      console.log(error.response)
                    }
                )
              }

            },
            (error) => {
              this.formDialogOptions.errorMessage = error.response.data.message;
            }
        );
      }
    },
    completeUploadSuccess: function (val) {
      if (
          this.itemModified.avatarImage !== undefined &&
          this.itemModified.avatarImage !== ""
      ) {
        FileService.deleteImage(this.itemModified.avatarImage).then(
            () => {
            },
            (error) => {
              console.log(error.response);
            }
        );
      }
      if (val.fileName !== "") {
        this.$refs.refUploadDialog.closeDialog();
        this.itemModified.avatarImage = val.fileName;
        // this.saveUpdateOnly();
      }
    },

    save(andCloseDialog) {

      if (this.isItemModified === false) {
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
        return;
      }

      if (this.$refs.form.validate()) {
        if (this.formMode === FormMode.EDIT_FORM && this.itemModified.id > 0 ) {
          if(this.itemModified.itemsPermit){
            const ftUmkmPermits = this.itemModified.itemsPermit.map( itemId => {
              return {
                fumkmBean: this.itemModified.id,
                fpermitBean: itemId,
                fdivisionBean: this.itemModified.fdivisionBean,
              }
            });
            this.itemModified.itemsPermit = ftUmkmPermits
          }
          FUmkmService.updateFUmkm(this.itemModified).then(
            () => {
              if (andCloseDialog) {
                FtUmkmPermitService.deleteAllFtUmkmPermitByParent(this.itemModified.id).then(
                    () => {

                      FtUmkmPermitService.createFtUmkmPermitMultiple(this.itemModified.itemsPermit).then(
                          () => {
                            this.initializeEditMode(this.itemModified)
                            this.$emit("eventFromFormDialogEdit", this.itemModified);
                            this.message = "Berhasil simpan data"
                          },
                          (error) => {
                            console.log(error.response)
                          }
                      )
                    },
                    (error) => {
                      console.log(error.response)
                    }
                )

              }
            },
            (error) => {
              this.errorMessage = error.response.data.message;
            }
          );
        }
        else if(this.itemModified.id === 0) {
          if (
              this.itemModified.fdivisionBean > 0 &&
              this.itemModified.description !== undefined &&
              this.itemModified.fsubAreaBean !== undefined &&
              this.itemModified.fumkmTypeBean !== undefined
          ) {
            if(this.itemModified.itemsPermit){
              const ftUmkmPermits = this.itemModified.itemsPermit.map( itemId => {
                return {
                  fumkmBean: 0,
                  fpermitBean: itemId,
                  fdivisionBean: this.itemModified.fdivisionBean,
                }
              });
              this.itemModified.itemsPermit = ftUmkmPermits
            }
            FUmkmService.createFUmkm(this.itemModified).then(
                (response) => {
                  if (andCloseDialog) {
                    if(this.itemModified.itemsPermit){
                      const newFtUmkmPermits = this.itemModified.itemsPermit.map( itemId => {
                        return {
                          fumkmBean: response.data.id,
                          fpermitBean: itemId.fpermitBean,
                          fdivisionBean: this.itemModified.fdivisionBean,
                        }
                      });
                      FtUmkmPermitService.deleteAllFtUmkmPermitByParent(response.data.id).then(
                          () => {

                            FtUmkmPermitService.createFtUmkmPermitMultiple(newFtUmkmPermits).then(
                                () => {
                                    this.$emit("eventFromFormDialogNew", response.data);
                                },
                                (error) => {
                                  console.log(error.response)
                                }
                            )
                          },
                          (error) => {
                            console.log(error.response)
                          }
                      )
                    }
                  }
                },
                (error) => {
                  this.formDialogOptions.errorMessage =
                      error.response.data.message;
                }
            );
          }
        }
      } //endif validate
    },

    saveUpdateOnly() {
      if(this.itemModified.itemsPermit){
        const ftUmkmPermits = this.itemModified.itemsPermit.map( itemId => {
          return {
            fumkmBean: this.itemModified.id,
            fpermitBean: itemId,
            fdivisionBean: this.itemModified.fdivisionBean,
          }
        });
        this.itemModified.itemsPermit = ftUmkmPermits
      }
      console.log(this.itemModified)
      FUmkmService.updateFUmkm(this.itemModified).then(
        () => {
          FtUmkmPermitService.deleteAllFtUmkmPermitByParent(this.itemModified.id).then(
              () => {

                FtUmkmPermitService.createFtUmkmPermitMultiple(this.itemModified.itemsPermit).then(
                    () => {
                      this.initializeEditMode(this.itemModified)
                    },
                    (error) => {
                      console.log(error.response)
                    }
                )
              },
              (error) => {
                console.log(error.response)
              }
          )

        },
        (error) => {
          this.errorMessage = error.response.data.message;
        }
      );
    },
    closeForm() {
      if (!this.isItemModified) {
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
      } else {
        this.$refs.refCloseConfirmDialog.showDialog(
          " Sudah terdapat modifikasi data",
          "Tetap tutup dan reset perubahan?"
        );
      }
    },
    passingEventFromCloseConfirm(value) {
      if (value === "OKE") this.dialogShow = false;
    },
    initializeEditMode(item) {
      this.errorMessage = "";

      FUmkmService.getFUmkmById(item.id).then(
        (response) => {
          // this.itemDefault = Object.assign({}, response.data);
          this.itemModified = response.data;
          this.itemModified.itemsPermit = this.itemModified.itemsPermit.map( item => item.fpermitBean);
          this.itemDefault = Object.assign({}, this.itemModified);
          this.$refs.refUmkmMarker.initialize(this.computedCurrentMarker);

          this.retrieveFiles();
          this.$refs.refFUmkmFileTable.fetchFUmkmFileByFUmkm(
              this.itemModified
          );
        },
        (error) => {
          console.log(error);
        }
      );
    },
    retrieveFiles() {
      FUmkmFileService.getAllFUmkmFileByParent(this.itemModified.id).then(
        (response) => {
          this.itemsFile = response.data;
        },
        (error) => {
          console.log(error.response);
        }
      );
    },


    fetchParent() {
      FPermitService.getAllFPermit().then(
          (response) => {
            this.$store.dispatch("umkm/updateItemsFPermit", response.data);
            this.itemsFPermit = response.data;
          },
          (error) => {
            console.log(error.response);
          }
      );
      FUmkmTypeService.getAllFUmkmType().then(
          (response) => {
            this.$store.dispatch("umkm/updateItemsFUmkmType", response.data);
            this.itemsFUmkmType = response.data;
          },
          (error) => {
            console.log(error.response);
          }
      );

      FAreaService.getAllFArea().then(
          (response) => {
            this.itemsFArea = response.data;
            this.$store.dispatch("umkm/updateItemsFArea", response.data);
          },
          (error) => {
            console.log(error);
          }
      );
      FSubAreaService.getAllFSubArea().then(
          (response) => {
            this.itemsFSubArea = response.data;
            this.$store.dispatch("umkm/updateItemsFSubArea", response.data);
          },
          (error) => {
            console.log(error);
          }
      );

    },
    lookupFArea(fareaBean) {
      const str = this.itemsFArea.filter((x) => x.id === fareaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_medium(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/no_image_available.jpeg");
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    formattedDatefns(value) {
      return value ? format(parseISO(value), "dd MMMM yyyy") : "";
    },
    backOrClose() {
      // this.$store.dispatch("auth/backOrClose");
      // this.$router.push("/login");
      this.dialogShow = false
    },

  },

  mounted() {
    this.fetchParent();
  }

};
</script>

<style scoped>
.show-btns {
  color: blue !important;
  opacity: 1;
}

</style>
